import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ReactEditor = ({ source = '', changeHandle, readOnly }) => {
    const _readOnly = readOnly || false;
    const toolbarOptions = [
        [
            { 'header': [1, 2, 3, 4, 5, 6, false] },
            { 'list': 'ordered'},
            { 'list': 'bullet' },
            { 'indent': '-1'},
            { 'indent': '+1' },
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            { 'color': [] },
            { 'background': [] },
            { 'align': [] }
        ],
        [ 'link', 'image' ]
    ];
    
    return (
        <ReactQuill theme="snow" modules={{ toolbar: toolbarOptions }} value={ source } placeholder={"Write something awesome..."} onChange={ changeHandle } readOnly = { _readOnly }/>
    );
};

export default React.memo(ReactEditor);